var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3986_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7065 4.18995C10.9743 4.44733 10.9792 4.86942 10.7174 5.1327L8.30871 7.55556H19.322C19.6965 7.55556 20 7.85403 20 8.22222C20 8.59041 19.6965 8.88889 19.322 8.88889H7.91694C6.83511 8.88889 6.35957 7.6088 7.07507 6.88909L9.74782 4.20064C10.0096 3.93735 10.4388 3.93257 10.7065 4.18995ZM4 11.7778C4 11.4096 4.30354 11.1111 4.67797 11.1111L16.0831 11.1111C17.1649 11.1111 17.6404 12.3912 16.9249 13.1109L14.2522 15.7994C13.9904 16.0626 13.5612 16.0674 13.2935 15.8101C13.0257 15.5527 13.0208 15.1306 13.2826 14.8673L15.6913 12.4444L4.67797 12.4444C4.30354 12.4444 4 12.146 4 11.7778Z",
    fill: "#4877F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3986_1111",
    x: 0,
    y: 0,
    width: 24,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2825 0 0 0 0 0.467067 0 0 0 0 0.941667 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_1111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_1111",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.5512c14cda062d4fe79fd7ce28c6cdda.svg";
export { ForwardRef as ReactComponent };